<template>
  <div class="bg">
    <a-row>
      <a-col :xs="24" :sm="{ span: 16, offset: 4 }" class="py-8">
        <!-- Email sent card -->
        <a-card
          v-if="authEmailSent"
          class="flex flex-col items-center w-full text-center rounded-md login-car"
        >
          <svgicon class="mb-8" name="sent" color="#ed8936" width="64" height="64"></svgicon>

          <div class="text-xl font-bold">
            Ti abbiamo inviato una email!
            <br />
            Controlla la tua casella di posta!
          </div>
          <p class="mt-8 text-center" :style="{ maxWidth: '56ch' }">
            Clicca sul link che trovi nella mail per accedere in modo sicuro all'area di gestione
            del tuo ordine!
          </p>
        </a-card>

        <!-- Auth order card -->
        <a-card v-if="showOrdersList && !authEmailSent" class="w-full mb-8 rounded-md">
          <h2 class="text-2xl">I tuoi ordini</h2>
          <p class="mb-8 opacity-75">
            Questi sono gli ordini con cui sei autenticato su questo dispositivo
          </p>

          <div class="flex items-center py-4 border-b" v-for="order in orders" :key="order.id">
            <span class="mr-1 text-lg font-bold opacity-50">#</span>
            <span class="font-mono text-lg font-bold">{{ order.code }}</span>
            <a-tag v-if="order.ui_step <= 5" class="ml-4" color="red">In corso</a-tag>

            <div class="flex justify-end flex-grow">
              <a
                @click="goToCurrentOrderStep"
                v-if="order.ui_step <= 5"
                class="font-semibold cursor-pointer text-i4m-orange"
              >
                Concludi ordine
              </a>

              <a @click="goToOrderArea" v-else class="font-semibold cursor-pointer text-i4m-orange">
                Vai all'area ordine
              </a>
            </div>
          </div>
        </a-card>

        <!-- Login for an order card -->
        <a-card v-if="!authEmailSent" class="mx-2 rounded-md lg:mx-0">
          <h2 class="mb-12 text-2xl">
            {{ showOrdersList ? 'Vuoi accedere ad un altro ordine?' : 'Recupera il tuo ordine' }}
          </h2>

          <div class="grid grid-cols-1 gap-8 md:grid-cols-2">
            <div class="hidden md:block">
              <h3 class="mb-8 text-lg">Nell'area del tuo ordine puoi:</h3>
              <div v-for="feat in features" :key="feat">
                <div class="flex items-center justify-start mb-4">
                  <a-icon
                    type="check-circle"
                    theme="twoTone"
                    twoToneColor="#52c41a"
                    :style="{ fontSize: '1.5rem' }"
                    class="mr-3"
                  />

                  <div>{{ feat }}</div>
                </div>
              </div>
            </div>

            <a-form
              id="components-form-demo-normal-login"
              :form="form"
              class="login-form"
              @submit="login"
            >
              <h3 class="mb-8 text-lg">Accedi all'area ordine</h3>
              <a-form-item>
                <label slot="label" class="font-bold ">Indirizzo email usato per l'acquisto</label>
                <a-input
                  v-decorator="[
                    'email',
                    {
                      rules: [
                        {
                          required: true,
                          message: $t('msg.required')
                        },
                        {
                          type: 'email',
                          message: $t('msg.requiredemail')
                        }
                      ]
                    }
                  ]"
                  placeholder="latuaemail@email.it"
                ></a-input>
              </a-form-item>
              <a-form-item>
                <label slot="label" class="font-bold ">Codice ordine</label>
                <a-input
                  v-decorator="[
                    'code',
                    { rules: [{ required: true, message: 'E\' obbligatorio' }] }
                  ]"
                  class="uppercase"
                  placeholder="AB123456"
                ></a-input>
              </a-form-item>
              <a-form-item>
                <a-button
                  type="primary"
                  html-type="submit"
                  :loading="this.logginIn"
                  class="login-form-button"
                >
                  Accedi
                </a-button>
              </a-form-item>
            </a-form>
          </div>
        </a-card>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import api from '@/api.js';

export default {
  name: 'order-login',
  components: {},
  data: function() {
    return {
      logginIn: false,
      authEmailSent: false,
      features: [
        'Visualizzare tutti i dettagli delle tue polizze',
        'Richiedere assistenza',
        'Aprire una segnalazione di sinistro su uno strumento',
        'Contattare uno dei nostri broker'
      ]
    };
  },

  beforeCreate() {
    this.form = this.$form.createForm(this, { name: 'orderLogin' });
  },

  computed: {
    showOrdersList() {
      return Object.keys(this.orders).length > 0;
    },

    loginEsit() {
      return this.$store.state.loginEsit;
    },

    orders() {
      let o = {};

      if (this.$store.state.order) {
        let order = this.$store.state.order;
        o[order.code] = order;
      }

      const authOrder = this.$store.state.authOrder;
      if (authOrder && !o[authOrder.code]) {
        o[authOrder.code] = authOrder;
      }

      return o;
    }
  },
  watch: {
    loginEsit: function(newVal, oldVal) {
      if (newVal == 'ko' && newVal !== oldVal) {
        this.showFailedLoginNotification();
        this.form.setFields({
          password: {
            value: ''
          }
        });
      }

      if (newVal == 'ok' && newVal !== oldVal) {
        this.$router.replace(this.$store.state.redirectAfterLogin || '/');
        this.$store.commit('setRedirectAfterLogin', null);

        this.$notification.success({
          message: this.$t('login.success'),
          duration: 5
        });

        this.$notification.destroy();
      }
    }
  },
  methods: {
    async login(e) {
      e.preventDefault();
      this.form.validateFields(async (err, values) => {
        if (err) return;

        this.logginIn = true;

        try {
          await api.orderLogin({ email: values.email, code: values.code });
        } catch (e) {
          console.log('Error loggin in');
          this.logginIn = false;
          return this.showFailedLoginNotification();
        }

        this.logginIn = false;

        this.authEmailSent = true;
      });
    },

    // goTo current order step
    goToCurrentOrderStep() {
      this.$store.commit('setActiveOrder', this.order);
      this.$router.push({ name: this.$store.getters.currentStep });
    },

    goToOrderArea() {
      this.$store.commit('setActiveOrder', this.authOrder);
      this.$router.push({ name: 'order' });
    },

    showFailedLoginNotification() {
      this.$notification.error({
        message: 'Nessun ordine corrisponde a queste credenziali',
        duration: 10,
        description: 'Controlla di aver inserito i dati corretti'
      });
    }
  }
};
</script>
<style lang="scss">
@import '@/variables.scss';
.login {
  padding-top: 4rem;
}

.login-card {
  margin: 1rem;

  @media #{$lg} {
    max-width: 400px;
  }
}

.login-form-button {
  width: 100%;

  &:not(:last-child) {
    margin-bottom: 0.75rem;
  }
}
</style>
